import React from 'react';
import { FileSearch, RefreshCcw } from 'lucide-react';

interface WorksheetEmptyStateProps {
  searchQuery: string;
}

export default function WorksheetEmptyState({ searchQuery }: WorksheetEmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center py-20 text-center">
      <div className="w-16 h-16 rounded-2xl bg-secondary flex items-center justify-center mb-5">
        <FileSearch size={28} className="text-primary" />
      </div>
      <h3 className="text-lg font-semibold text-foreground mb-2">
        No worksheets found
      </h3>
      <p className="text-sm text-muted-foreground max-w-sm mb-6">
        {searchQuery
          ? `No worksheets match "${searchQuery}". Try a different search term or browse by category.`
          : 'No worksheets are available in this category yet. Check back soon or browse another topic.'}
      </p>
      <a href="/" className="btn-secondary">
        <RefreshCcw size={14} />
        Clear Filters
      </a>
    </div>
  );
}